import React from 'react';
// Backend URLs
// export const backendURL = 'https://avogadro.azurewebsites.net';
export const backendURL = 'http://localhost:8000'; // For local Django Server

// Key for Autocomplete API
export const AutocompleteKey = '2ov7JqmEAsdGnP51xLa0tDQ7GcxUx6ieeZ1XP8QT8JAzSeBfb6PD';
export const AutocompleteVer = '2019-05-06';
export const AutoCompleteTop = 25; // Number of results to be fetched from the API
export const AutoCompleteRes = 25; // Max. no of results to be populated in the AutoComplete list

const domain = 'https://codecarbonhq-avogadrosearch.search.windows.net/';
const path = 'indexes/';
const env_suffix = process.env.UMI_APP_ENVIRONMENT === 'staging' ? '-devstage' : '';

// Inspection List:
export const InspectionSuggester = 'inspection_suggester';
// export const InspectionFields = 'country,city,site_address,company_name,normalized_company_city';
export const InspectionFields = 'country,normalized_company_city';
export const InspectionURL = `${domain + path}fda-inspections-index${env_suffix}/docs/suggest`;

// Sites List:
export const SiteSuggester = 'site_suggester';
// export const SiteFields =
//  'name,company_name,company_address,city,country,address,normalized_company_city';
export const SiteFields = 'name,company_name,country,normalized_company_city';
export const SiteURL = `${domain + path}fda-site-index${env_suffix}/docs/suggest`;

export const UsfdaRecallSiteSuggester = 'usfda_recall_data_suggester';
export const RecallSiteFields = 'recalling_firm_name,country,fei_number';
export const UsfdaRecallURL = `${domain + path}usfda_recall_index${env_suffix}/docs/suggest`;
export const recallProductBaseUrl = 'https://www.accessdata.fda.gov/scripts/ires/?Product=';
// Tga autocomplete List data api
export const TGARecallSiteSuggester = 'tga_recall_data_suggester';
export const TGARecallSiteFields = 'tga_recall_reference,company';
export const TgaRecallURL = `${domain + path}tga-recall-index${env_suffix}/docs/suggest`;
// Mhra_Eu autocomplete List data api:

export const MhraEuSuggester = 'mhra_eu_inspection_suggester';
export const MhraEuFields = 'site_name,site_address,country,normalized_site_name';
export const MhraEuURL = `${domain + path}mhra-eu-inspections-index${env_suffix}/docs/suggest`;

// Inspectors List:
export const InspectorSuggester = 'investigator_index_suggester';
export const InspectorFields =
  'normalized_with_middle_name,normalized_name,first_name,last_name,organization';
export const InspectorURL = `${domain + path}fda-investigator-index${env_suffix}/docs/suggest`;

// Warning Letters List:
export const WLSuggester = 'warning_letter_suggester';
export const WLFields =
  'warning_letter_subject,warning_letter_content,warning_letter_company,warning_letter_issuing_office';
export const WLURL = `${domain + path}fda-warning-letter-index${env_suffix}/docs/suggest`;

// Drug Analytics List:
export const DrugSuggester = 'drug_suggester';
export const DrugFields = 'brand_name,generic_name';
export const DrugURL = `${domain + path}fda-drug-content-index${env_suffix}/docs/suggest`;

// Company Profile List
export const CompanySuggester = 'company_suggester';
export const CompanyFields = 'company_name';
export const CompanyURL = `${domain + path}fda-company-profile-index${env_suffix}/docs/suggest`;

// Observation Content Suggester
export const ObsSuggester = 'observation_content_suggester';
export const ObsCitationFields = 'matched_citation_reference_list';
export const ObsURL = `${domain + path}fda-observation-content-index${env_suffix}/docs/suggest`;

// Downloads APIs
const downloadAPI = '/inspections/api/downloads/';
export const download483 = `${downloadAPI}483`;
export const download483r = `${downloadAPI}483_response`;
export const downloadeir = `${downloadAPI}eir`;
export const downloademhraeu = `${downloadAPI}mhra_eu_gmp`;
export const downloadtrending483 = `${downloadAPI}trendings483`;
export const downloadresponseletters = `${downloadAPI}response_letters`;
export const downloadCrlPdf = `${downloadAPI}crl_document`;
export const downloadSampleSupplyChainFile = `${downloadAPI}sample_supply_chain_file`;
export const downloadSwissGmdpCertificate = '/swiss_gmdp/api/download_certificate/';
export const userRequestURL = '/inspections/api/user_document_requests/';

// WatchList Constants
export const watchListAddTypeString = 'Add';
export const watchListRemoveTypeString = 'Remove';
export const watchListUpdateVisitedTypeString = 'UpdateVisited';
export const watchListUpdateSuccessString = 'Success';
export const watchListUpdateFailString = 'Fail';
export const watchListTypeStringMhra = 'WATCHLIST_TYPE_MHRA';
export const watchListTypeStringEudra = 'WATCHLIST_TYPE_EU';
export const watchListTypeStringRRA = 'WATCHLIST_TYPE_RRA';
export const watchListTypeStringOrg = 'WATCHLIST_TYPE_ORG';


export const filterOptions = require('@/assets/filters_data.json');
export const drugFilterOptions = require('@/assets/drug_filters_data.json');
export const citationFilterOptions = require('@/assets/citation_filters_data.json');
export const countryNameCodeMap = require('@/assets/mapping_data.json');

// GeoLocation: https://geolocation-db.com
export const GeoLocationKey = '0f761a30-fe14-11e9-b59f-e53803842572';

// SEO Enopoints
const env = window.location.href.includes('localhost') ? 'dev' : 'prod';

const JSONURL = 'https://atlas-seo-b7a2dnajhqe5addh.z03.azurefd.net';
// const JSONURL = 'https://atlasfrontendcchq.blob.core.windows.net';

const SEOBase = `${JSONURL}/seo-data/${env}/seo_base`;

export const SEOListEP = `${SEOBase}/list_folder/investigators/`;
export const SEOProfileEP = `${SEOBase}/profile_folder/investigators/`;

export const SiteMapEP = `${SEOBase}/sitemap.xml`;

export const SUBSCRIBER_USER_TYPE = 6666;
export const USER_MANAGEMENT_USER_TYPE = 3333;
// super user having access of both fda and mhra_eu
export const SUBSCRIBER_SUPER_USER_TYPE = 9999;
export const SUBSCRIBER_USER_TYPE_FOR_WEEKLY_UPDATES = 7777;
export const BLOCKED_USER_TYPE = 0

// user for watchlist tracking
export const WATCHLIST_TRACKING_USER_TYPE = 88888;

// Emails granted early access to watchlist-tracking-gated features
// (e.g. the site detail page's Product Mapping tab) regardless of user type.
export const WATCHLIST_TRACKING_ALLOWLISTED_EMAILS = [
  'bhavish@codecarbonhq.com',
  'kavita@codecarbonhq.com',
  'deepak@fdalytics.com',
  'cvicent3@its.jnj.com',
];

// Internal beta: who can view the Resume tab / use the "Request Resume" button (must match
// InvestigatorResumeConstants.RESUME_VIEW_ALLOWED_EMAILS in Avogadro/inspections/constants.py).
export const INVESTIGATOR_RESUME_ALLOWLISTED_EMAILS = [
  'deepak@fdalytics.com',
  'bhavish@codecarbonhq.com',
  'kavita@codecarbonhq.com',
];

// Subset of the above who can actually upload a resume file (must match
// InvestigatorResumeConstants.RESUME_UPLOAD_ALLOWED_EMAILS in Avogadro/inspections/constants.py).
export const INVESTIGATOR_RESUME_UPLOAD_ALLOWLISTED_EMAILS = [
  'deepak@fdalytics.com',
  'bhavish@codecarbonhq.com',
];

// user for Medical device
export const SUBSCRIBER_MEDICAL_DEVICE_USER_TYPE = 1111;

export const DATA_TYPING_USER_TYPE = 2222;

// Scoped to Labelling/USFDA + RxLabel Intelligence only, not a general subscriber type.
export const RXLABEL_USFDA_USER_TYPE = 44444;

export const domainURL = 'http://localhost:8000';
// export const domainURL = 'https://atlas.codecarbonhq.com';

export const testSubEmail = 'test_subscribed@dhan.ai';
export const testSubPW = 'testAc';

export const testNonSubEmail = 'test_nonsub@fdalytics.com';
export const testNonSubPW = 'testNSAc';

// Establishment Type Empty message
export const establishmentEmptyMessage = <p>Please Search Establishment Type like API ,<br />
  Manufacturer, Drug Manufacturer etc.</p>

export const operationsEmptyMessage = <p>Please Search Operations like <br />
  Analysis, Manufacturer etc.</p>

export const cpgmCodesEmptyMessage = <p>Please Search CPGM Codes<br /></p>

export const testingTeam = [
  'vishrut@fdalytics.com',
  'chirag@fdalytics.com',
  'sairohanj@fdalytics.com',
  'leomessi@fcb.cat',
  'bhavish@dhan.ai',
  'chakri@dhan.ai',
  'bhavish@fdalytics.com',
  'chakri@fdalytics.com',
  'chiragsoni.soni007@gmail.com',
  'rohan@gmail.com',
];

export const FREE_USER_TYPE = 1;

export const disclaimer = `This feature is experimental and relies on an Artificial Intelligence model that is continually learning and evolving.
                        You are requested to verify the responses.`

export const supportEmail = 'support@codecarbonhq.com'

export const EmailSubscriptionURLMapping = {
  '/fda_crl': 'crl_data',
  '/enforcement/warning-letters': 'warning_letter',
  '/trending_483': 'trending_notifications',
}
export const MICROSOFT_CLIENT_ID = "25f2e51d-7e8a-4632-9bb9-aef07f87cedd"
